import { Avatar, Button, MenuItem, ListItemIcon, ListItemText, Typography } from "@mui/material"
import { styled, alpha } from "@mui/material/styles"
import { useAuth } from "hooks/useAuth"
import { enRules, routeConfig } from "interfaces/IUser"
import { CSSProperties, useRef, useState } from "react"
import { FaUserAlt } from "react-icons/fa"
import { MdLogout } from "react-icons/md"
import { useLocation, useNavigate } from "react-router"
import { MenuPopover } from "shared"

const ButtonStyle = styled(Button)({ borderRadius: "3rem" })

const NameUser = styled(Typography)({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  paddingLeft: "0.5rem",
  lineHeight: "1.1rem",
  color: "#757575",
  "& strong": {
    color: "#353535",
  },
})

const AvatarStyle = styled(Avatar)(({ theme }) => ({
  background: "#F8974C",
}))

const MenuItemStyle = styled(MenuItem)(({ theme }) => ({
  minWidth: "12rem",
  "&:hover": {
    background: alpha(theme.palette.secondary.main, 0.1),
  },
}))

interface IProps {
  style: CSSProperties
}

export const UserNav = ({ style }: IProps) => {
  const userRef = useRef(null)
  const { painelRules } = routeConfig
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const {
    signOut,
    user: { username, rules },
  } = useAuth()
  const [popover, setPopover] = useState(false)

  const togglePopover = () => setPopover(state => !state)
  const canAccessPainel = painelRules.some(rule => rules.includes(rule))
  const canReplenishment = rules.includes(enRules.ReplenishmentReplenisher)

  const actionBlocked = (action: any) => {
    togglePopover()
    action()
  }

  const onClickPanel = () => {
    if (rules.includes(enRules.ReplenishmentDashboardView)) {
      actionBlocked(() => navigate("/painel-de-admin/dashboard"))
      return
    } else if (rules.includes(enRules.ReplenishmentBalanceView)) {
      actionBlocked(() => navigate("/painel-de-admin/balanco"))
      return
    } else if (rules.includes(enRules.ReplenishmentStockoutView)) {
      actionBlocked(() => navigate("/painel-de-admin/sem-estoque"))
      return
    }
    actionBlocked(() => navigate("/operacao/abastecimento"))
  }

  return (
    <>
      <ButtonStyle onClick={togglePopover} style={style}>
        <AvatarStyle ref={userRef}>
          <FaUserAlt />
        </AvatarStyle>
        <NameUser>
          Olá, <br />
          <strong>{username}</strong>
        </NameUser>
      </ButtonStyle>

      <MenuPopover
        open={popover}
        onClose={togglePopover}
        anchorEl={userRef.current}
        style={{ marginTop: "1rem" }}
      >
        {!pathname.includes("painel-de-admin") && canAccessPainel && (
          <MenuItemStyle onClick={onClickPanel}>
            <ListItemIcon>
              <MdLogout size={22} />
            </ListItemIcon>
            <ListItemText>Painel</ListItemText>
          </MenuItemStyle>
        )}

        {!pathname.includes("painel-de-operador/abastecimento") && (
          <MenuItemStyle
            onClick={() => actionBlocked(() => navigate("/painel-de-operador/abastecimento"))}
          >
            <ListItemIcon>
              <MdLogout size={22} />
            </ListItemIcon>
            <ListItemText>Abastecer</ListItemText>
          </MenuItemStyle>
        )}

        <MenuItemStyle onClick={signOut}>
          <ListItemIcon>
            <MdLogout size={22} />
          </ListItemIcon>
          <ListItemText>Sair da conta</ListItemText>
        </MenuItemStyle>
      </MenuPopover>
    </>
  )
}
